import { Component, OnInit } from '@angular/core';
import {DeviceTypeService} from '../../device-type/device-type.service';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderServiceService} from '../order-service/order-service.service';
import {ClientServiceService} from '../../client/client-service/client-service.service';

@Component({
  selector: 'app-order-form',
  templateUrl: './order-form.component.html',
  styleUrls: ['./order-form.component.css']
})
export class OrderFormComponent implements OnInit {

  deviceTypeList: any = [];
  createOrderItemList: any = [];
  currrentItem: any;
  clientId: any;
  cId: any;
  orderId: string='';
  client: any;
  loading: boolean;
  isEdit: boolean;
  submitted: boolean;
  constructor( private router: Router,
              private orderService: OrderServiceService,
              private deviceTypeService: DeviceTypeService,
              private clientService: ClientServiceService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {
    this.route.fragment.subscribe(fragment => { this.cId = fragment; });
    this.route.params.subscribe(routeParams => {this.orderId = routeParams.orderIdParam; });
    if(this.orderId===undefined){
      this.orderId='';
    }
    if(this.cId === undefined){
        this.cId = localStorage.getItem('clientId');
    }
    this.client = this.getClientDetails(this.cId);
  }

  ngOnInit() {
    if(this.orderId!==''){

        this.loading = true;
        this.orderService.getOrder(this.orderId)
          .subscribe(data => {
            if (data.status === 200) {
              const response: any = data.json();
              this.createOrderItemList = response.orderItems.itemsList;
              console.log(response.devicetypes);
              this.loading = false;
            } else {
              this.toastr.error('', 'Please try again');
            }
          }, (error) => {
            this.loading = false;
            // this.toastr.error('', 'Please try again');
          });

    }
    this.getAllDeviceTypes();
    this.initCurrentItem();

  }

  addItem() {
      if(this.currrentItem.quantity < 1){
        this.toastr.error('', 'Invalid quantity selected!');
        return;
      }
      for (var devType of this.deviceTypeList) {
          if(devType.id === this.currrentItem.id){
              this.currrentItem.deviceName=devType.name;
          }
      }

      for (var orderItems of this.createOrderItemList) {
          if(orderItems.id === this.currrentItem.id){
               if(this.isEdit){
                    orderItems.quantity=this.currrentItem.quantity;
                    this.toastr.success('', orderItems.deviceName+' is updated successfully, Changed quantity to: '+orderItems.quantity);
                    this.isEdit=false;
               }else{
                    orderItems.quantity=orderItems.quantity+this.currrentItem.quantity;
                    this.toastr.success('', orderItems.deviceName+' already present in item list, Updated quantity to: '+orderItems.quantity);
               }

               this.currrentItem= {
                      id: 'Please select',
                      deviceName: null,
                      quantity: null
               };

               return;
          }
      }

      this.createOrderItemList.push(this.currrentItem);
      //this.toastr.success('', 'Add Item:'+this.currrentItem.id+', Q:'+this.currrentItem.quantity);
      this.currrentItem= {
              id: 'Please select',
              deviceName: null,
              quantity: null
       };

  }

  editItem(item){

      for (var orderItems of this.createOrderItemList) {
          if(orderItems.id === item.id){
               this.isEdit=true;
               this.currrentItem= {
                      id: orderItems.id,
                      deviceName: null,
                      quantity: orderItems.quantity
               };

               return;
          }
      }

  }

  removeItem(item){
      let newOrderItemList: any = [];
      for (var orderItems of this.createOrderItemList) {
          if(orderItems.id !== item.id){
               newOrderItemList.push(orderItems);
          }
      }
      this.createOrderItemList=newOrderItemList;
  }

  initCurrentItem(){

        this.currrentItem= {
              id: 'Please select',
              deviceName: null,
              quantity: null
        };
  }

  public createOrder() {
    this.loading = true;
    this.submitted = true;

   if(!(this.createOrderItemList.length>0)){
          this.toastr.error('', 'Please add items to order!');
          return;
    }

    const orderDataForm: any= {
          id: this.orderId,
          items: this.createOrderItemList
    };

    this.orderService.createOrder(orderDataForm, this.cId)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Order saved successfully');
            this.router.navigate(['/elasticcare/order']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          const errorRes: any = error.json();
          this.toastr.error('', errorRes.message);
          this.loading = false;
        });
  }

  public cancelOrderCreation() {
            this.router.navigate(['/elasticcare/order']);
            this.loading = false;
  }

  public getAllDeviceTypes() {
    this.loading = true;
    this.deviceTypeService.getAllDeviceTypes()
        .subscribe(data => {
          if (data.status === 200) {
            const response: any = data.json();
            this.deviceTypeList = response.devicetypes;
            console.log(response.devicetypes);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

  public getClientDetails(clientId: any) {
    this.clientService.getClientById(clientId)
        .pipe(first())
        .subscribe(data => {
          console.log('client ::' + data.json())
          this.client = data.json();
        }, (error) => {
          this.toastr.error('', 'Please try again');
        });
  }

}
